<ng-template #content let-modal>
    <div [ngClass]="{ 'alert': message }" class="modal-header" [attr.data-modal]="message?.dataModal">
        <h2 class="modal-title">{{ message?.type === 'LOCKOUT' ? 'INFO' : message?.type }}</h2>
        <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body text-center">
        <p [innerHTML]="message?.text"></p>
        @if (message?.type === 'LOCKOUT' && countdownSeconds > 0) {
            <p class="countdown-text">Please try again in {{ countdownMinutes }} minute(s) {{ countdownRemainingSeconds }} second(s).</p>
        }
        @if (message?.type === 'LOCKOUT' && countdownSeconds === 0) {
            <p class="countdown-text">You may try again now.</p>
        }
    </div>
    <div class="modal-footer" [class.justify-content-between]="message?.action">
        <button (click)="modal.close('Close click')" class="btn btn-light" type="button">Close</button>
        @if (message?.action) {
            @switch (message.action.type) {
                @case ('link') {
                    <a [href]="message.action.url" [ngClass]="message.action.cssClass"
                       [attr.target]="message.action.openInNewTab ? '_blank' : '_self'"
                       [attr.rel]="message.action.openInNewTab ? 'noopener noreferrer' : null">{{ message.action.label }}</a>
                }
            }
        }
    </div>
</ng-template>
